// context/ThemeContext.js
import { createContext } from 'react';

const ThemeModeContext = createContext({
  mode: 'light',
  toggleTheme: () => {},
});

export default ThemeModeContext;
